// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.5 4C5.5 2.62 6.62 1.5 8 1.5C9.38 1.5 10.5 2.62 10.5 4V5C10.5 6.38 9.38 7.5 8 7.5C6.62 7.5 5.5 6.38 5.5 5V4Z',
  'M11.99 14.05C12.61 13.36 12.67 12.42 12.13 11.67L11.86 11.34C10.82 10.21 9.45 9.62 8.02 9.59C6.6 9.62 5.18 10.21 4.14 11.34L3.87 11.67C3.33 12.42 3.39 13.36 4.01 14.05C4.26 14.34 4.63 14.5 5.02 14.5L10.98 14.5C11.37 14.5 11.74 14.34 11.99 14.05Z',
];
